import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { ErrorMessage, Input } from "@nju/form";
import { salesRoutes } from "@nju/routes";
import { Button, Panel, Separator } from "@nju/ui";
import { checkClientPanelMachine } from "./checkClientPanel.machine";

export function CheckClientPanel() {
  const router = useRouter();

  const [current, send] = useMachine(checkClientPanelMachine, {
    actions: {
      redirectToClientStatus: (_, event) => {
        if (event.type === "GO_TO_CLIENT_STATUS") {
          router.push(salesRoutes.statusKlienta.get());
        }
      },
      redirectToClientInProgress: (_, event) => {
        if (event.type === "CLIENT_LOCKED_BY_OTHER_AGENT") {
          router.push(salesRoutes.klientObslugiwany.get());
        }
      },
    },
  });

  const { context } = current;
  const { formError, email } = context;

  const handleSubmit: React.FormEventHandler<HTMLFormElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        send({ type: "SUBMIT" });
      },
      [send],
    );

  const handleEmailChange: React.ChangeEventHandler<HTMLInputElement> =
    React.useCallback(
      ({ target }) => {
        send({ type: "SET_INPUT_VALUE", name: "email", value: target.value });
      },
      [send],
    );

  return (
    <div data-cy="check-client-section">
      <Panel iconName="search" title="sprawdź klienta">
        <form
          autoComplete="false"
          className="flex flex-col gap-4 from-desktop:items-start from-desktop:flex-row"
          onSubmit={handleSubmit}
        >
          <div className="w-full">
            <Input
              label="e-mail klienta"
              name="email"
              onChange={handleEmailChange}
              type="text"
              value={email}
            />
            {formError && (
              <>
                <Separator size="xxs" tone="invisible" />
                <ErrorMessage message={formError} />
              </>
            )}
          </div>

          <Button
            isLoading={!current.matches("ready")}
            size={{ "@initial": "s", "@fromTablet": "m" }}
            type="submit"
            variant="secondary"
          >
            sprawdź
          </Button>
        </form>
      </Panel>
    </div>
  );
}
